export default {
  quantities        : ['4', '10', '50', '100'],
  part_number       : '',
  revision          : '',
  bom_line_items    : '',
  smt               : '',
  thru_hole         : '',
  bga               : '',
  qfn               : '',
  double_sided_smt  : '0',
  lead_free         : '0',
  class_3_inspection: '0',
  fine_pitch        : '0',
  assembly_restrictions: !isManager,
};
